import { render, staticRenderFns } from "./AppAutoImg.vue?vue&type=template&id=fcdabe94&scoped=true"
import script from "./AppAutoImg.vue?vue&type=script&lang=js"
export * from "./AppAutoImg.vue?vue&type=script&lang=js"
import style0 from "./AppAutoImg.vue?vue&type=style&index=0&id=fcdabe94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdabe94",
  null
  
)

export default component.exports